import getValue from './getValue';

const getValueFromObjectList = (arr = []) =>
  arr.find(el => {
    const obj = getValue(el);
    el.value = obj.value;
    el.property = obj.key;

    return obj.value !== null;
  });

export default getValueFromObjectList;
